import { armorPageColumn } from "../resource/armor-page-column";
import { NeededColumn } from "./needed-column";

export const armorPageNeededColumn = new NeededColumn(
  "d2c30cba-fdd1-490e-82d9-7f1740521770",
  armorPageColumn,
  "Blue Page Needed"
)
